import type { TypedDocumentNode } from "@apollo/client";
import type { InputMetadata } from "@charterindex/halyard";
import type { CrudOperationConfig, CrudOperationResult, CrudSubmitContext } from "./crud-operation";
import type { JSX } from "react";
import { createElement } from "react";
import { Editor } from "../editor/editor";
import { CrudOperation } from "./crud-operation";




export type CreateOperationViewProps<Attributes> = { id: null, editor: Editor<Attributes>, operation: CreateOperation<Attributes, any> }; // eslint-disable-line @typescript-eslint/no-explicit-any
export type CreateOperationView<Attributes> = (props: CreateOperationViewProps<Attributes>) => JSX.Element;
type CreateOperationMutationVariables<Attributes> = { attributes: Attributes };

export type CreateOperationConfig<Attributes, Result> = CrudOperationConfig & {
	view: CreateOperationView<Attributes>;
	data: Partial<Attributes>;
	metadata: InputMetadata<Attributes>;
	mutation: TypedDocumentNode<Result, CreateOperationMutationVariables<Attributes>>;
};
export class CreateOperation<Attributes, Result> extends CrudOperation<Result> {
	readonly #config: CreateOperationConfig<Attributes, Result>;
	readonly editor: Editor<Attributes>;
	readonly view: () => JSX.Element;

	constructor(config: CreateOperationConfig<Attributes, Result>) {
		super(config);
		this.#config = config;
		this.editor = new Editor({
			data: config.data,
			metadata: config.metadata,
		});
		this.view = () => createElement(config.view, { id: null, editor: this.editor, operation: this });
	}

	override async initialise(): Promise<void> { /**/ }

	override async submit({ refetchQueries }: CrudSubmitContext): Promise<CrudOperationResult<Result>> {
		const attributes = {
			...this.#config.data,
			...this.editor.changedValues,
		};

		const result = await this.services.api.mutation(this.#config.mutation, { refetchQueries })
			.submit({ attributes }) as Result;

		return {
			status: "ok",
			value: result,
		};
	}

	override dispose(): void {
		this.editor.dispose();
	}

	override hasChanges(): boolean {
	  return this.editor.changed;
	}
}
